import axios from 'axios'

/**
 * Soft deletes a device from the backend API by id.
 * @param {object} data - The data object with the device id and the notify method for alerts.
 */
export default function deleteDevice ({ commit, state, dispatch }, data) {
  axios.delete(`${process.env.VUE_APP_API_URL}/api/devices/${data.device_id}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': localStorage.getItem('user-token')
    }
  })
    .then(function (response) {
      if (data.level === 0) {
        dispatch('getAllDevices')
      } else {
        dispatch('getAdminDevices')
      }

      data.notify({
        group: 'foo-velocity',
        title: `Device successfully deleted!`,
        text: `<br><br>`,
        type: 'success'
      })
    })
    .catch(function (error) {
      console.log(error)
    })
}
